<template>
  <el-dialog title="更换头像" :visible.sync="innerVisible" width="420px" append-to-body>
    <div class="avatar-grid">
      <button
        v-for="avatar in avatars"
        :key="avatar.filename"
        type="button"
        class="avatar-option"
        :class="{ selected: selected === avatar.filename }"
        @click="selected = avatar.filename"
      >
        <el-avatar :size="56" :src="avatarUrl(avatar.filename)"><i class="el-icon-user-solid" /></el-avatar>
      </button>
    </div>
    <span slot="footer">
      <el-button @click="innerVisible = false">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateAvatar } from '../api/auth'
import { authBus } from '../store/auth'
import { AVATARS, DEFAULT_AVATAR, avatarUrl } from '../config/avatars'

export default {
  name: 'ProfileDialog',
  props: { visible: { type: Boolean, default: false } },
  data() { return { avatars: AVATARS, selected: DEFAULT_AVATAR, loading: false } },
  computed: {
    innerVisible: {
      get() { return this.visible },
      set(value) { this.$emit('update:visible', value) }
    }
  },
  watch: {
    visible(value) {
      if (value && authBus.user) this.selected = authBus.user.avatarFilename
    }
  },
  methods: {
    avatarUrl,
    async save() {
      this.loading = true
      try {
        const { data } = await updateAvatar(this.selected)
        if (data.code !== 200) throw new Error(data.message || '头像修改失败')
        authBus.setUser(data.data)
        this.innerVisible = false
        this.$message.success('头像已更新')
      } catch (error) {
        this.$message.error(error.response && error.response.data ? error.response.data.message : error.message)
      } finally { this.loading = false }
    }
  }
}
</script>

<style scoped>
.avatar-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; }
.avatar-option { padding: 8px; cursor: pointer; background: var(--surface); border: 2px solid transparent; border-radius: var(--r-md); }
.avatar-option.selected { border-color: var(--brand); background: var(--brand-soft); }
</style>
